// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"DirectBillingSummary_sectionHeader__1YMHG","link":"DirectBillingSummary_link__18ftE"};